import * as msal from '@azure/msal-browser';

// this is for holding the data that comes back.
const data = {};
let ready = false;

const msalInstance = new msal.PublicClientApplication({
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
    authority: process.env.VUE_APP_MSAL_AUTHORITY,
    tenantId: process.env.VUE_APP_MSAL_TENANT_ID,
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
    knownAuthorities: [process.env.VUE_APP_MSAL_KNOWN_AUTHORITY],
    validateAuthority: false,
    autoRefreshToken: true,
    navigateToLoginRequestUrl: false,
  },
  request: {
    scopes: ['openid', process.env.VUE_APP_MSAL_SCOPE],
  },
});

const waitForInteraction = async () => {
  while (msalInstance.interactionInProgress || !ready) {
    await new Promise((resolve) => setTimeout(resolve, 100)); // eslint-disable-line no-await-in-loop
  }
};

const getAccountNoWait = () => {
  const currentAccounts = msalInstance.getAllAccounts();
  if (currentAccounts && currentAccounts.length > 0) {
    return currentAccounts[0]; // eslint-disable-line prefer-destructuring
  }
  return null;
};

const getAccount = async () => {
  await waitForInteraction();
  const currentAccounts = msalInstance.getAllAccounts();
  if (currentAccounts && currentAccounts.length > 0) {
    return currentAccounts[0]; // eslint-disable-line prefer-destructuring
  }
  return null;
};

const isAuthenticated = async () => {
  await waitForInteraction();
  data.user = await getAccount();
  return !!data.user;
};

const authenticate = () => msalInstance.loginRedirect(); // eslint-disable-line prefer-destructuring
const logout = () => msalInstance.logout; // eslint-disable-line prefer-destructuring
const acquireTokenSilent = (request) => new Promise((resolve) => msalInstance.acquireTokenSilent(request).then((tokenResponse) => resolve(tokenResponse)).catch((error) => {
  if (error instanceof msal.BrowserAuthError) {
    console.log('To be expected with Auth');
  } else {
    console.log(error);
  }
}));
const acquireTokenRedirect = (request) => msalInstance.acquireTokenRedirect(request);

msalInstance.handleRedirectPromise().then(async (response) => {
  if (response !== null) {
    if (response.account) data.user = response.account;
    if (response.accessToken) data.accessToken = response.accessToken;
    if (response.idTokenClaims) data.claims = response.idTokenClaims;
    ready = true;
  } else {
    const loggedInAccount = getAccountNoWait();
    data.user = loggedInAccount;

    if (data.user) {
      // already have an account; do a token request to get claims
      const tokenResponse = await acquireTokenSilent({
        scopes: [process.env.VUE_APP_MSAL_SCOPE],
        account: data.user,
      });
      data.accessToken = tokenResponse.accessToken;
      if (tokenResponse.account) data.user = tokenResponse.account;
      if (tokenResponse.idTokenClaims) data.claims = tokenResponse.idTokenClaims;
    }
  }
  ready = true;
}).catch((error) => {
  console.log(error); // eslint-disable-line no-console
});

/* eslint-disable import/prefer-default-export */
export {
  data,
  isAuthenticated,
  authenticate,
  logout,
  acquireTokenSilent,
  acquireTokenRedirect,
  waitForInteraction,
};
